/**
 * Validates input string based on common patterns.
 *
 * @param {string} value - The input string to validate.
 * @param {string} type - The validation type ('alphanumeric', 'alphanumericWithSpaces', 'alphaOnly', 'numbersOnly')
 * @returns {boolean} - Returns true if the input matches the pattern, otherwise false.
 */
export const validateInput = (value, type) => {
  if (!value) return true; // Allow empty string for clearing inputs

  const patterns = {
    // Letters and numbers only, no spaces or special chars
    alphanumeric: /^[a-zA-Z0-9]*$/,

    // Letters, numbers, and spaces only
    alphanumericWithSpaces: /^[a-zA-Z0-9\s]*$/,

    // Letters and spaces only
    alphaWithSpaces: /^[a-zA-Z\s]*$/,

    // Numbers only
    numbersOnly: /^[0-9]*$/,

    // Common Course Name: Letters, numbers, spaces, and limited symbols like -, (, ), &, /
    courseName: /^[a-zA-Z0-9\s\-()&/]*$/,
  };

  const regex = patterns[type];
  if (!regex) {
    console.warn(`Validation type "${type}" is not defined.`);
    return true;
  }

  return regex.test(value);
};

/**
 * Sanitizes input allowing only specific characters. For use in onChange handlers.
 *
 * @param {string} value - The input value to sanitize.
 * @param {string} type - The sanitization type.
 * @returns {string} - The sanitized string.
 */
export const sanitizeInput = (value, type) => {
  const replacementPatterns = {
    alphanumeric: /[^a-zA-Z0-9]/g,
    alphanumericWithSpaces: /[^a-zA-Z0-9\s]/g,
    alphaWithSpaces: /[^a-zA-Z\s]/g,
    numbersOnly: /[^0-9]/g,
    textInput: /$^/g,
    Pincode: /$^/g,
  };

  const regex = replacementPatterns[type];
  if (!regex) return value;

  return value.replace(regex, "");
};
